import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function similar to FlutterFlow

// Function to manage viewers for a folder
const resetAccesses = async (folderid, orgid, token, prefix) => {
  // Define the endpoint URL
  const url = prefix + `folders/${folderid}/orgs/${orgid}/reset-accesses`;

  // Define the request body
  const body = {};

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);

    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document (avoid passing full document references)
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      folderid || "",

      "", // docid
      JSON.stringify(body), // request body as string
      await response.text() // response body as string
    );

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response (currently returns an empty string on success)
      return "";
    } else {
      console.error(`Failed to manage viewers: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default resetAccesses;
